import React from "react";
import CoffeeCardSection from "../components/CoffeeCardSection";

function CoffeePreview(props) {
  return (

      <CoffeeCardSection
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="caffè la primavera"
      subtitle=""
      />
  );
}

export default CoffeePreview;
